export const PLANT_DETAILS = () => {
  return {
    installationName: {
      key: "installationName",
      required: true,
      maxChar: 250,
    },
    description: {
      key: "description",
      multiline: "3",
      maxChar: 500,
    },
    city: {
      key: "city",
      maxChar: 100,
    },
  };
};

export const WATER_TYPE = (t) => {
  return [t("waterType.seawater"), t("waterType.surfaceWater"), t("waterType.wellWater"), t("waterType.wastewater")];
};
